module.exports = __webpack_public_path__ + "img/9.3b08c080.webp";